import dayjs from "dayjs";
import { Empty, Table } from "antd";
// import { useSelector } from "react-redux";
import { formatDateAndTime } from "components/Common/Utils";
import { UNITS } from "components/Common/Constants";
import { useCallback, useEffect, useState } from "react";
import { getApis } from "components/Common/apis";
import { vehicleAutoTripsUrl } from "components/Common/endpoints";

const TripsTable = ({ vehicle, startTime, endTime }) => {
  // const startTime = useSelector((state) => state.filter.startTime);
  // const endTime = useSelector((state) => state.filter.endTime);
  const authToken = localStorage.getItem("authToken");

  const [tripsTableData, setTripsTableData] = useState({
    list: [],
    totalElements: 0,
  });
  const [paginationDetails, setPaginationDetails] = useState({
    current: 1,
    pageSize: 25,
  });

  const getAutoTripsData = useCallback(
    async (currentPage) => {
      const startDate = dayjs(startTime);
      const timeFilter = startDate.diff(endTime, "month")
        ? "MONTHLY"
        : startDate.diff(endTime, "week")
        ? "WEEKLY"
        : "DAILY";
      await getApis(
        vehicleAutoTripsUrl,
        {
          imei: vehicle?.vehImei,
          from:
            dayjs(endTime) > dayjs().subtract(1, "hour")
              ? Math.floor(
                  dayjs().subtract(
                    1,
                    timeFilter === "MONTHLY"
                      ? "month"
                      : timeFilter === "WEEKLY"
                      ? "week"
                      : "day"
                  )
                )
              : startTime,
          to:
            dayjs(endTime) > dayjs().subtract(1, "hour")
              ? Math.floor(dayjs())
              : endTime,
          page: currentPage - 1,
          size: paginationDetails.pageSize,
          sort: "id,desc",
        },
        authToken
      )
        .then((res) => {
          if (res.status === 200) {
            setTripsTableData({
              list: res?.data?.data,
              totalElements: res?.data?.totalElements,
            });
          }
        })
        .catch((e) => {
          setTripsTableData({
            list: [],
            totalElements: 0,
          });
          console.log(e);
        });

      // eslint-disable-next-line
    },[authToken, vehicle?.vehImei, startTime, endTime]
  );

  useEffect(() => {
    if (vehicle?.vehImei && vehicle?.vehImei !== "") {
      if (paginationDetails?.current) {
        setPaginationDetails((prev) => ({ ...prev, current: 1 }));
      }
      getAutoTripsData(1);
    }

    if (dayjs(endTime) > dayjs().subtract(1, "hour")) {
      const intervalId = setInterval(() => {
        if (vehicle?.vehImei && vehicle?.vehImei !== "") {
          getAutoTripsData(paginationDetails?.current);
        }
      }, 60 * 1000);

      return () => clearInterval(intervalId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getAutoTripsData, vehicle?.vehImei]);

  const handlePageChange = (pagination) => {
    setPaginationDetails({
      current: pagination.current,
      pageSize: pagination.pageSize,
    });
    getAutoTripsData(pagination.current);
  };

  const columns = [
    {
      title: "Time",
      dataIndex: "time",
      key: "time",
      width: "46%",
      className: "grey",
      render: (_, record) =>
        dayjs(record?.startTime).date() === dayjs(record?.endTime).date() ? (
          <>
            <div className="f12">
              {dayjs(record?.startTime).format("MMM DD YYYY")}
            </div>
            <div className="f12">
              {dayjs(record?.startTime).format("hh:mm A")} to{" "}
              {dayjs(record?.endTime).format("hh:mm A")}
            </div>
          </>
        ) : (
          <>
            <div className="f12">{formatDateAndTime(record?.startTime)}</div>
            <div className="f12">{formatDateAndTime(record?.endTime)}</div>
          </>
        ),
    },
    {
      title: "Distance",
      dataIndex: "distance",
      key: "distance",
      align: "center",
      className: "grey align-text-top",
      render: (distance) => `${distance} ${UNITS.KM}`,
    },
    // {
    //   title: "Duration",
    //   dataIndex: "duration",
    //   key: "duration",
    //   className: "grey align-text-top",
    //   render: (duration) => formatHourAndMins(duration),
    // },
  ];

  return tripsTableData?.list?.length > 0 ? (
    <Table
      data-testid="ride-histories"
      columns={columns}
      dataSource={tripsTableData?.list}
      rowKey={(record) => record.testId}
      className="mb05"
      scroll={{
        x: "100%",
        y:
          tripsTableData?.totalElements > paginationDetails.pageSize
            ? 320
            : 380,
      }}
      onChange={handlePageChange}
      pagination={{
        current: paginationDetails.current,
        pageSize: paginationDetails.pageSize,
        total: tripsTableData?.totalElements,
        showSizeChanger: false,
        showQuickJumper: false,
        hideOnSinglePage: true,
      }}
    />
  ) : (
    <div className="pd3025" data-testid="empty-ride-histories">
      <Empty />
    </div>
  );
};
export default TripsTable;
